import React from 'react'
import {
  SettingsMenuButtonWithIcon,
  SettingsMenuButtonWithIconProps,
} from 'src/editor/shared/components/settings-menu-buttons/settings-menu-button-with-icon'

interface SettingsMenuButtonWithIconAndBorderProps
  extends SettingsMenuButtonWithIconProps {}

export const SettingsMenuButtonWithIconAndBorder = ({
  ...props
}: SettingsMenuButtonWithIconAndBorderProps) => {
  return (
    <SettingsMenuButtonWithIcon
      className="rounded-lg border-1 border-border100 p-2"
      {...props}
    />
  )
}
